import React, {useState, useEffect, useCallback, useRef} from 'react';
import { withTranslation } from "react-i18next";
import { Modal, OverlayTrigger, Tooltip, Button } from "react-bootstrap";
import { AiFillQuestionCircle, HiExclamationCircle } from "react-icons/hi"

import { URL_API } from "../../constants/urls";
import { useHistory } from "react-router-dom";
import HelpModal from "./HelpModal";
import Get from "../../api/Get";
import { GET_APPOINTMENT_BY_ID } from "../../api/Routes";
import { isConsultorio } from "../../utils/isConsultorio";

const MSG_DIAGNOSTICO_REQUERIDO =
    "Primero debes definir el diagnóstico antes de enviar la historia clínica";

const Transcripcion = ({ t, cita, data, setShowEncuesta, setReload, setCita, appointmentId, validDiagnostico = false }) => {

    const [url, setUrl] = useState('');
    const [showButton, setShowButton] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [isValid, setIsValid] = useState(false);
    const [isComplete, setIsComplete] = useState(false);
    const history = useHistory();
    const [showModal, setShowModal] = useState({ visible: false, title: '', data: [] });
    const [showWarningModal, setShowWarningModal] = useState(false);
    const role = data.role === 'Doctor' ? '1' : '0';
    const validDiagnosticoRef = useRef(validDiagnostico);
    /** Evita doble cierre si el usuario pulsa Finalizar y HiSmart también envía postMessage */
    const hismartFinalizeDoneRef = useRef(false);
    /** Consultorio + iframe: detecta cuando el backend actualiza HC sin depender solo de postMessage */
    const consultorioHcPollLastRef = useRef(null);
    useEffect(() => {
        validDiagnosticoRef.current = validDiagnostico;
    }, [validDiagnostico]);

    useEffect(() => {
        if (openModal) {
            hismartFinalizeDoneRef.current = false;
        }
    }, [openModal]);

    useEffect(() => {
        if (!openModal || role !== '0' || !isConsultorio(data.role) || !appointmentId) {
            return undefined;
        }
        consultorioHcPollLastRef.current = JSON.stringify(cita?.medicalHistoryDTO ?? null);
        let cancelled = false;
        const intervalMs = 4500;
        const poll = async () => {
            try {
                const response = await Get({
                    url: `${GET_APPOINTMENT_BY_ID}/${appointmentId}`,
                    access_token: data.access_token,
                });
                const next = response?.data?.data;
                if (cancelled || !next) return;
                const snap = JSON.stringify(next.medicalHistoryDTO ?? null);
                if (snap !== consultorioHcPollLastRef.current) {
                    consultorioHcPollLastRef.current = snap;
                    if (setCita) setCita(next);
                    if (setReload) setReload(true);
                }
            } catch {
                /* ignorar errores de red puntuales */
            }
        };
        const id = setInterval(poll, intervalMs);
        poll();
        return () => {
            cancelled = true;
            clearInterval(id);
        };
    }, [openModal, role, data.role, appointmentId, data.access_token, cita, setCita, setReload]);

    useEffect(() => {
        const validationAppointment = async () => {
            return (cita.appointmentStatus === 'Pagada' && cita.finished === false);
        }

        const hismartApi = async () => {
            // En teleconsultation 0 para domicilio y 1 para teleconsulta

            const urlHismart = await fetch(`${URL_API}/api/hismart/geturl`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${data.access_token}`,
                },
                body: JSON.stringify({
                    "id_physician": `${cita.scheduleDTO.doctor.id}`,
                    "id_patient": `${cita.patientDTO.id}`,
                    "id_attention": `${cita.id}`,
                    "id_process": "599",
                    "instructive": "Favor de preguntar los siguientes puntos:1. Motivo de Consulta " +
                        "2. Enfermedad Actual 3. Antecedentes Patológicos 4. Antecedentes Farmacológicos " +
                        "5. Antecedentes Toxicológicos 6. Antecedentes Hospitalarios 7. Antecedentes Alérgicos " +
                        "8. Antecedentes Quirúrgicos 9. Antecedentes Ginecológicos 10. Antecedentes Traumáticos " +
                        "11. Antecedentes Familiares 12. Revisión por sistemas 13. Signos Vitales 14. Exploración física " +
                        "15. Estudios de laboratorio y gabinete 16. Medicamento 17 Posología 18. Presentación " +
                        "19. Vía de administración 20. Tiempo 21. Reacción adversa 22. Análisis 23. Plan " +
                        "24. Recomendación médica",
                    "context": cita.motivoConsulta,
                    "teleconsultation": role
                })
            });
            if (!urlHismart.ok) {
                console.log('url hismart failed');
            }
            const response = await urlHismart.json();
            console.log(response);
            if (response.status === "true") {
                setUrl(response.url);
                setShowButton(false);
            } else {
                console.log("Respuesta inesperada:", response);
            }

        }

        const handleClick = async () => {
            if (!validDiagnosticoRef.current) {
                window.alert(MSG_DIAGNOSTICO_REQUERIDO);
                return;
            }
            setOpenModal(true);
            if (cita && data && !url) {
                hismartApi()
            }
        };

        let elem = null;
        let hiSmartButton = null;
        const onSidebarHiSmartClick = () => {
            handleClick();
        };

        const validations = async () => {
            validationAppointment().then((value) => {
                if (value) {
                    elem = document.getElementById('idSeccionConferencia');
                    if (elem) {
                        hiSmartButton = elem.querySelector('button');
                        setTimeout(() => {
                            elem.removeAttribute('hidden');
                        }, 1000)
                        if (hiSmartButton) {
                            hiSmartButton.disabled = !validDiagnosticoRef.current;
                            hiSmartButton.title = !validDiagnosticoRef.current ? MSG_DIAGNOSTICO_REQUERIDO : "";
                        }
                        elem.addEventListener('click', onSidebarHiSmartClick);
                    }
                    setIsValid(true);
                }
            })
        }


        validations();
        return () => {
            if (elem) {
                elem.removeEventListener('click', onSidebarHiSmartClick);
            }
        };
    }, [cita, data, url]);

    useEffect(() => {
        const elem = document.getElementById('idSeccionConferencia');
        if (!elem) return;
        const hiSmartButton = elem.querySelector('button');
        if (!hiSmartButton) return;
        hiSmartButton.disabled = !validDiagnostico;
        hiSmartButton.title = !validDiagnostico ? MSG_DIAGNOSTICO_REQUERIDO : "";
    }, [validDiagnostico]);

    const notifyInteractionIsFinished = useCallback(async () => {
        try {
            const urlHismart = await fetch(`${URL_API}/api/hismart/gethistory`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${data.access_token}`,
                },
                body: JSON.stringify({
                    "appointment_id": `${cita.id}`,
                    "is_finished": true,
                })
            });

            if (!urlHismart.ok) {
                console.error('Error al notificar el cierre de la interacción');
                return;
            }

            const response = await urlHismart.json();
            console.log('hi-smart: ', response);
            return response;
        } catch (error) {
            console.error("Error en notifyInteractionIsFinished:", error);
        }
    }, [data.access_token, cita.id, URL_API]);

    useEffect(() => {
        const messageHandler = async (event) => {
            if (event.origin === "https://app.hismart.ai" && event.data === "finished_process") {
                if (hismartFinalizeDoneRef.current) {
                    return;
                }
                try {
                    await notifyInteractionIsFinished();
                    setIsComplete(true);
                    setOpenModal(false);

                    // Fetch updated appointment to get medical history ID
                    if (setCita && appointmentId) {
                        try {
                            const response = await Get({
                                url: `${GET_APPOINTMENT_BY_ID}/${appointmentId}`,
                                access_token: data.access_token,
                            });
                            if (response.data.data) {
                                setCita(response.data.data);
                            }
                        } catch (error) {
                            console.error("Error fetching updated appointment:", error);
                        }
                    }

                    // Trigger reload of ProvHistoriaClinica component
                    // Add small delay to ensure cita state is updated first
                    setTimeout(() => {
                        if (setReload) {
                            setReload(true);
                        }
                    }, 500);

                    /* No abrir encuesta aquí: cerrarla dispara handleCloseEncuesta → history.replace("/admin").
                       La encuesta sigue mostrándose al terminar la videollamada / flujo normal de cita. */
                    setTimeout(() => {
                        const elem = document.getElementById('idSeccionConferencia');
                        if (elem) {
                            elem.setAttribute('hidden', 'hidden');
                        }
                    }, 1000);

                    hismartFinalizeDoneRef.current = true;

                } catch (error) {
                    console.error("Error en messageHandler:", error);
                }
            }
        };

        window.addEventListener("message", messageHandler);

        return () => {
            window.removeEventListener("message", messageHandler);
        };
    }, [notifyInteractionIsFinished, setIsComplete, setOpenModal, setReload, setCita, appointmentId, data.access_token]); // Incluir notifyInteractionIsFinished

    const handleFinalizarHiSmart = async () => {
        if (!validDiagnostico) {
            window.alert(MSG_DIAGNOSTICO_REQUERIDO);
            return;
        }
        if (hismartFinalizeDoneRef.current) {
            return;
        }
        try {
            await notifyInteractionIsFinished();
            hismartFinalizeDoneRef.current = true;
            setOpenModal(false);
            alert("Proceso Finalizado.\nEl análisis con la IA de HiSmart ha concluido. Ya puedes revisar la Historia Clínica actualizada.");
            setIsComplete(true);
            
            // Fetch updated appointment to get medical history ID
            if (setCita && appointmentId) {
                try {
                    const response = await Get({
                        url: `${GET_APPOINTMENT_BY_ID}/${appointmentId}`,
                        access_token: data.access_token,
                    });
                    if (response.data.data) {
                        setCita(response.data.data);
                    }
                } catch (error) {
                    console.error("Error fetching updated appointment:", error);
                }
            }
            
            // Trigger reload of ProvHistoriaClinica component
            // Add small delay to ensure cita state is updated first
            setTimeout(() => {
                if (setReload) {
                    setReload(true);
                }
            }, 500);
        } catch (error) {
            console.error("Error al finalizar HiSmart:", error);
            hismartFinalizeDoneRef.current = false;
            alert("Ocurrió un error al finalizar HiSmart. Por favor, inténtelo nuevamente.");
        }
    };

    useEffect(() => {
        const blockNavigation = (e) => {
            e.preventDefault();
            e.stopPropagation();
            window.history.pushState(null, "", window.location.href);
        };
    
        if (openModal) {
            window.history.pushState(null, "", window.location.href);
            window.addEventListener("popstate", blockNavigation);
        }
    
        return () => {
            window.removeEventListener("popstate", blockNavigation);
        };
    }, [openModal]);

    useEffect(() => {
        console.log(openModal, " <- openModal change");

        const showLockScreen = () => {
            setShowWarningModal(true);
        };

        const handleVisibilityChange = () => {
            if (document.hidden && openModal) {
                showLockScreen();
            }
        };

        if (openModal) {
            document.addEventListener("visibilitychange", handleVisibilityChange);
        }

        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, [openModal]);

    const handleCloseModal = () => {
        if (isComplete) {
            setOpenModal(false);
            return;
        }

        if (role !== '0') {
            setOpenModal(false);
            return;
        }

        const answer = window.confirm("Los datos del historial clínico se perderán al cerrar este modal. ¿Estás seguro de cerrarlo?");
        if (answer) {
            setOpenModal(false);
        }
    };

    const causeData = [
        ["743", "Accidente de trabajo (Atención del embarazo y el Posparto)"],
        ["744", "Accidente de tránsito"],
        ["745", "Accidente rábico"],
        ["746", "Accidente ofídico"],
        ["747", "Otro tipo de accidente"],
        ["748", "Evento catastrófico"],
        ["749", "Lesión por agresión"],
        ["750", "Lesión auto infligida"],
        ["751", "Sospecha de maltrato físico"],
        ["752", "Sospecha de violencia sexual"],
        ["753", "Sospecha de maltrato emocional"],
        ["754", "Enfermedad general"],
        ["755", "Enfermedad profesional"],
        ["756", "Otra causa externa"],
    ];

    const glasgowData = [
        ["582", "1"], ["605", "2"], ["606", "3"], ["583", "4"], ["584", "5"],
        ["585", "6"], ["586", "7"], ["587", "8"], ["588", "9"], ["589", "10"],
        ["590", "11"], ["591", "12"], ["592", "13"], ["593", "14"], ["594", "15"],
    ];

    const openSmallWindow = () => {
        if (!validDiagnostico) {
            window.alert(MSG_DIAGNOSTICO_REQUERIDO);
            return;
        }
        window.open(url, 'conferenciaWindow', `width=400, height=400, left=200, top=200, resizable=yes, scrollbars=yes`);
    };

    return (isValid
        && (<div>
            {(
                <Modal show={openModal}
                       onHide={handleCloseModal}
                       centered
                       className="responsive-modal border-0"
                       keyboard={false}>

                    <Modal.Header closeButton>
                        <h6>Asistente Hi Smart </h6>
                        <OverlayTrigger
                            placement='left'
                            overlay={<Tooltip> Tipo de consulta
                                <table className="table text-white">
                                    <tr><td>741</td> <td>Primera vez</td> </tr>
                                    <tr><td>742</td> <td>Control</td> </tr>
                                </table>
                            </Tooltip>}
                        >
                            <HiExclamationCircle className='fa fa-help clicked text-primary' fontSize={25} />
                        </OverlayTrigger>

                        <HiExclamationCircle
                            title="Ver Causa Externa"
                            className='fa fa-help clicked text-primary'
                            fontSize={25}
                            style={{ cursor: 'pointer' }}
                            onClick={() => setShowModal({ visible: true, title: 'Causa Externa', data: causeData })}
                        />

                        <OverlayTrigger
                            placement='left'
                            overlay={<Tooltip> Prórroga
                                <table className="table text-white">
                                    <tr><td>45</td><td>Si</td></tr>
                                    <tr><td>46</td><td>No</td></tr>
                                </table>

                            </Tooltip>}
                        >
                            <HiExclamationCircle className='fa fa-help clicked text-primary' fontSize={25} />
                        </OverlayTrigger>

                        <HiExclamationCircle
                            title="Ver Escala de Glasgow"
                            className='fa fa-help clicked text-primary'
                            fontSize={25}
                            style={{ cursor: 'pointer' }}
                            onClick={() => setShowModal({ visible: true, title: 'Escala de Glasgow', data: glasgowData })}
                        />

                        <HelpModal
                            show={showModal.visible}
                            onHide={() => setShowModal({ visible: false, title: '', data: [] })}
                            title={showModal.title}
                            tableData={showModal.data}
                        />

                    </Modal.Header>

                    <Modal.Body className="p-2">
                        {role === '0' ? (
                            <>
                                <iframe src={url} title="Contenido" style={{ width: '100%' }} allow="camera; microphone"/>
                                {isConsultorio(data.role) && (
                                    <p className="small text-muted mt-2 mb-0 text-center">
                                        La historia clínica se actualizará automáticamente cuando HiSmart guarde los cambios (y también al finalizar la consulta).
                                    </p>
                                )}
                            </>
                        ) : (
                            <div className="border rounded p-3 bg-light">

                                <h5 className="mb-3 text-primary fw-bold">
                                    Instructivo para el uso de HiSmart durante la consulta
                                </h5>

                                <ol className="small mb-4">
                                    <li className="mb-2">
                                        Presione el botón <strong>"Iniciar HiSmart"</strong>. Se abrirá una ventana
                                        emergente con la interfaz de la Inteligencia Artificial.
                                    </li>

                                    <li className="mb-2">
                                        Dentro de la ventana de HiSmart, pulse el botón de grabación de color <strong
                                        className="text-danger">rojo</strong>.
                                        El sistema solicitará permisos para grabar su pantalla.
                                        <ul className="mt-2">
                                            <li>Seleccione <strong>"Pantalla completa"</strong>.</li>
                                            <li>Elija la pantalla que desea compartir.</li>
                                            <li>
                                                <strong>Habilite</strong> la opción para compartir el audio del sistema.
                                            </li>
                                            <li>Haga clic en <strong>"Compartir"</strong>.</li>
                                        </ul>
                                    </li>

                                    <li className="mb-2">
                                        A partir de ese momento, comenzará la grabación de toda la llamada con el
                                        paciente. Puede <strong>minimizar</strong> la ventana de HiSmart y continuar
                                        con la consulta normalmente.
                                    </li>

                                    <li className="mb-2">
                                        Al finalizar la consulta:
                                        <ul className="mt-2">
                                            <li>
                                                <strong>Primero</strong>, finalice la sesión con la IA. La ventana de
                                                HiSmart se cerrará automáticamente.
                                            </li>
                                            <li>
                                                <strong>Segundo</strong>, Presione el botón
                                                <strong>"Finalizar HiSmart"</strong>.
                                            </li>
                                            <li>
                                                <strong>Tercero</strong>, finalice la llamada con el paciente
                                                en <strong>Jitsi</strong>.
                                            </li>
                                        </ul>
                                    </li>

                                    <li>
                                        Finalmente, podrá <strong>verificar la transcripción</strong> generada por la IA
                                        y corregir los campos necesarios una vez que la página se haya recargado.
                                    </li>
                                </ol>

                                <div className="text-center mt-3 justify-content-center gap-3">
                                    <button
                                        onClick={openSmallWindow}
                                        className="btn btn-primary mx-4 shadow"
                                    >
                                        Iniciar HiSmart
                                    </button>
                                    <button
                                        onClick={handleFinalizarHiSmart}
                                        className="btn btn-danger shadow"
                                    >
                                        Finalizar HiSmart
                                    </button>
                                </div>

                            </div>
                        )}
                    </Modal.Body>
                </Modal>
            )}

            {/* Modal de advertencia para reemplazar la alerta */}
            {role === '0' && (
                <Modal show={showWarningModal} onHide={() => setShowWarningModal(false)} centered>
                    <Modal.Header closeButton>
                    <Modal.Title>Advertencia</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>Por favor, permanezca en esta sección mientras la grabación esté activa.</p>
                        <p>Cambiar de pestaña o salir de esta pantalla podría interrumpir o reiniciar la grabación.</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={() => setShowWarningModal(false)}>
                            Entendido
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}

        </div>)
    );
};

export default withTranslation()(Transcripcion);